import { useRouter } from 'next/router'
import React from 'react'

import { bindHover } from 'material-ui-popup-state/core'
import { usePopupState } from 'material-ui-popup-state/hooks'
import { useIntl } from 'react-intl'

import CarIcon from 'app/assets/icons/header/car.svg'
import IconButton from 'app/components/base/IconButton'
import Popper from 'app/components/common/Popover'

import HeaderButtonContainer from '../layouts/HeaderButtonContainer'

const MyGarageHeaderButton = () => {
  const intl = useIntl()
  const router = useRouter()

  const popupState = usePopupState({
    variant: 'popper',
    popupId: 'myGaragePopoverId'
  })

  return (
    <HeaderButtonContainer>
      <IconButton
        onClick={() => router.push('/profile/my-garage')}
        {...bindHover(popupState)}
      >
        <CarIcon />
      </IconButton>

      {popupState.isOpen && (
        <Popper
          placement="bottom"
          text={intl.formatMessage({ defaultMessage: 'My Garage' })}
          popupState={popupState}
        />
      )}
    </HeaderButtonContainer>
  )
}

export default MyGarageHeaderButton
